import { FC } from "react";
import { StarFilledIcon } from "@smile2impress/components";
import { Flex, Icon } from "@smile2impress/components/relaunch";

import { StarsProps } from "./Stars.types";

export const Stars: FC<StarsProps> = ({ rating, blockProps, iconProps }) => (
    <Flex direction={"row"} gap="1px" {...blockProps}>
        {Array.from({ length: 5 }, (_, index) => (
            <Icon
                as={StarFilledIcon}
                key={index}
                color={
                    index + 1 > rating
                        ? "secondary.gunmetal"
                        : "rgba(121, 199, 119, 1)"
                }
                {...iconProps}
            />
        ))}
    </Flex>
);
